<div class="modal fade" id="magicInsightsBulkUnlock" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="generateCustomInsightsModalLabel"><i class="fal fa-wand-sparkles"></i> Unlock Magic
          Insights</h5>
        <button type="button" class="close" data-dismiss="modal">
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12">
            <p>You are about to unlock Magic Insights for {{companyIds.length}} {{ companyIds.length | i18nPlural:pluralMappings.company}}.
            </p>
            <span>Select the Magic Insights Module to activate for these companies:</span>
            <div class="bg-light mb-2 pt-2 pl-2 max-height-20vh">
              @for (module of modulesInfo; track $index) {
                <label class="full-width">
                  <input type="radio" [value]="module.id" [(ngModel)]="selectedModuleId" name="selectedModules" (ngModelChange)="handleSelectedModuleIdsChange()"/>
                  {{ module.name }}
                </label>
                <!--TODO: <label class="full-width">
                  <input type="checkbox" [value]="module.id" [(ngModel)]="module.checked" name="selectedModules" (ngModelChange)="handleSelectedModuleIdsChange()"/>
                  {{ module.name }}
                </label> -->
              }
            </div>
          
            <p *ngIf="totalCreditsCost" class="border-bottom pb-2 text-right">
              This will use <sup>*</sup><em>up to</em><strong class="ml-1">{{ totalCreditsCost }}</strong> Magic Insights {{totalCreditsCost | i18nPlural: pluralMappings.credit}}.
            </p>
            
            <small class="text-grey-600">
              <sup>*</sup>Credits will only be used for companies where Magic Insights are available and have not yet been unlocked.
            </small>
            
            
            @if (!loadingState.loadingUnlockMagicInsightsModules){
              <button class="d-block mx-auto my-3 rounded-btn-base rounded-btn-vivid-outline btn-p-lg" [disabled]="!selectedMagicModuleIds?.length"
                (click)="confirmUnlockMIForSelectedCompanies()">
                <i class="fal fa-check mr-1"></i>Confirm
              </button>
              }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>